angular.module('unica_grand_prix.grand_prix_services', []);